import { msalInstance } from "../authConfig";
// import { BrowserAuthError } from "@azure/msal-browser";

const tokenRequest = {
    //VARIABLE
    scopes: process.env.VUE_APP_ROOT_SCOPES.split(","),
};



const msalAuth = {
    computed: {
        loginRequest() {
            return this.$store.state.languages.languages[this.$store.state.currentLangNo];
        },
        isLoggedIn() {
            const currentAccounts = msalInstance.getAllAccounts();
            return currentAccounts.length > 0;
        },
        userFullName() {
            const currentAccounts = msalInstance.getAllAccounts();
            if (currentAccounts.length > 0) {
                return currentAccounts[0].name;
            }
        },
    },
    methods: {
        login() {
            msalInstance.loginRedirect({})
            .catch(() => {
                sessionStorage.clear("msal.interaction.status");
                msalInstance.loginRedirect({})
            })
        },
        async getAccessToken() {
            console.log("GETTING SILENT TOKEN REQUEST");
            console.log("TOKEN FOR: ", msalInstance);
            let myToken = null;
            await msalInstance
                .acquireTokenSilent(tokenRequest)
                .then((res) => {
                    myToken = res.accessToken;
                })
                .catch(async (err) => {
                    if (!(err)) {
                        console.warn(err);
                    } else {
                        console.log("NO LOGGED IN USER");
                        console.warn(err);
                    }
                });

            return myToken;
        },
        async getToken() {
            let status = false;
            await msalInstance
                .acquireTokenSilent(tokenRequest)
                .then((res) => {
                    localStorage.setItem("access_token", res.accessToken);
                    status = true;
                })
                .catch(async (e) => {
                
                    console.log(e)
                    status = false;
        
                });

            return status;
        },
        logout() {
            // let self = this;
            const currentAccounts = msalInstance.getAllAccounts();
            if (currentAccounts.length > 0) {
                const logoutRequest = {
                    account: currentAccounts[0],
                    mainWindowRedirectUri: "/",
                    postLogoutRedirectUri: "/",
                };
                localStorage.removeItem("access_token");

                msalInstance.logoutRedirect(logoutRequest);
            }
         
        },
        forcelogout() {
            const currentAccounts = msalInstance.getAllAccounts();
            if (currentAccounts.length > 0) {
                const logoutRequest = {
                    account: currentAccounts[0],
                    mainWindowRedirectUri: "/",
                    postLogoutRedirectUri: "/",
                };

                msalInstance.logoutRedirect(logoutRequest);
            } else {
                window.location = "/";
            }

        },
    },
    beforeCreate() {},
    mounted() {},
};

export default msalAuth;

